import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Pagination } from "@/components/molecules/Pagination";
import { PaginationType } from "@/models/common";
import { TableContainer } from "@mui/material";
import { AccidentReportsConstants, getClassificationLabel, getTypeLabel } from "./AccidentReportsConstants";
import { AccidentReport } from "@/models/accidentReport";
import { getShortDatetime } from "@/util/datetime";

export type AccidentReportsListProps = {
  onChangePage: (page: number) => void;
  pagingData: PaginationType;
  reports: AccidentReport[];
};

export const AccidentReportsList = (props: AccidentReportsListProps) => {
  const {
    onChangePage,
    reports,
    pagingData,
  } = props;

  return (
    <React.Fragment>
      <TableContainer className="table-container-width">
        <Table size="small" className="list-head">
          <TableHead>
            <TableRow>
              <TableCell>
                {AccidentReportsConstants.RadioNumber}
              </TableCell>
              <TableCell>
                {AccidentReportsConstants.Classification}
              </TableCell>
              <TableCell>
                {AccidentReportsConstants.Type}
              </TableCell>
              <TableCell>
                {AccidentReportsConstants.HappenedAt}
              </TableCell>
              <TableCell>
                {AccidentReportsConstants.ReportedAt}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reports.map((row) => (
              <TableRow key={row.id} hover sx={{ wordBreak: "break-all" }}>
                <TableCell>
                  {row.vehicleCode ?? ""}
                </TableCell>
                <TableCell>
                  {getClassificationLabel(row.classification)}
                </TableCell>
                <TableCell>
                  {getTypeLabel(row.type)}
                </TableCell>
                <TableCell>
                  {getShortDatetime(row.happenedAt)}
                </TableCell>
                <TableCell>
                  {getShortDatetime(row.reportedAt)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        total={pagingData.total}
        page={pagingData.page}
        size={pagingData.size}
        setPage={onChangePage}
      />
    </React.Fragment>
  );
};
